import {
  ROLE_SALON_ADMIN,
  ROLE_SYSTEM_ADMIN,
  ROLE_JDTECH_ADMIN,
} from "../../utils/constants";

const ADMIN_ROLES = [ROLE_SALON_ADMIN, ROLE_SYSTEM_ADMIN, ROLE_JDTECH_ADMIN];

export function isClientAdmin(userRoles) {
  return ADMIN_ROLES.some((role) => userRoles?.includes(role));
}
